import { useEffect, useState } from 'react';
import { History } from './screens/History.tsx';
import { PrivacyPolicy } from './screens/Legal.tsx';
import { Notes } from './screens/Notes.tsx';
import { Onboarding } from './screens/Onboarding.tsx';
import { Today } from './screens/Today.tsx';
import { You } from './screens/You.tsx';
import { useModel } from './state.tsx';
import { Icon } from './ui/components.tsx';

const TABS = [['today', 'Today'], ['history', 'History'], ['notes', 'Notes'], ['you', 'You']] as const;
type Tab = (typeof TABS)[number][0];
const tabFromHash = (): Tab => (TABS.find(([t]) => `#${t}` === location.hash)?.[0] ?? 'today');

export function App() {
  const model = useModel();
  const [tab, setTab] = useState<Tab>(tabFromHash);
  useEffect(() => {
    const on = () => setTab(tabFromHash());
    addEventListener('hashchange', on);
    return () => removeEventListener('hashchange', on);
  }, []);
  useEffect(() => {
    // Pick up notes and links that arrived over WhatsApp while the app was in the background.
    const on = () => { if (document.visibilityState === 'visible' && model.phase === 'main') void model.refresh(); };
    document.addEventListener('visibilitychange', on);
    return () => document.removeEventListener('visibilitychange', on);
  }, [model]);

  if (model.phase === 'launching') return <div className="empty" style={{ paddingTop: '40dvh' }}>Loading…</div>;
  if (model.phase === 'onboarding') return <Onboarding />;

  return (
    <>
      {tab === 'today' && <Today />}
      {tab === 'history' && <History />}
      {tab === 'notes' && <Notes />}
      {tab === 'you' && <You />}
      {model.notice && <div className="toast" role="status">{model.notice}</div>}
      <div className="tabbar">
        <nav aria-label="Main">
          {TABS.map(([t, label]) => (
            <button key={t} aria-current={tab === t ? 'page' : undefined} data-testid={`tab-${t}`}
              onClick={() => { history.replaceState(null, '', `#${t}`); setTab(t); scrollTo(0, 0); }}>
              <Icon name={t} />{label}
            </button>
          ))}
        </nav>
      </div>
    </>
  );
}

/** Public page (no sign-in) so the policy has a stable URL: /privacy. */
export function PublicPolicy() {
  return <div className="screen plain"><PrivacyPolicy /><a href="/">Open Recover</a></div>;
}
